<template>
  <svg
    :width="width ? width : height ? height * (16 / 15) : 16"
    :height="height ? height : width ? width * (15 / 16) : 15"
    viewBox="0 0 16 15"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M10.804.8907h3.0976c1.0047 0 1.8195.8295 1.8195 1.8524l-.0346 8.1916a.64.64 0 0 1-.64.6373h-1.4489a.64.64 0 0 1-.64-.643l.0342-7.2597h-2.9567a.448.448 0 0 1-.1242-.0174h-2.87l.0371 4.5927h3.0551c.3969 0 .6033.481.3344.7775l-4.4198 4.8747a.4498.4498 0 0 1-.6687 0L.9593 9.0221c-.269-.297-.062-.7775.3344-.7775h3.055l-.0372-5.519c0-1.0228.8148-1.8524 1.8195-1.8524H10.68a.448.448 0 0 1 .1241.0175z"
      :fill="iconColor"
      fill-rule="nonzero"
    />
  </svg>
</template>

<script>
export default {
  name: 'uturnleft',
  props: {
    iconColor: {
      type: String,
      default: '#F94094',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
